export const PERMISSIONS = {
  accessMain: [{ action: 'plugin::i18n.locale.read', subject: null }],
  create: [{ action: 'plugin::i18n.locale.create', subject: null }],
  delete: [{ action: 'plugin::i18n.locale.delete', subject: null }],
  update: [{ action: 'plugin::i18n.locale.update', subject: null }],
  read: [{ action: 'plugin::i18n.locale.read', subject: null }],
};
